/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit FirstName/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function FirstName({
  children,
  viewPath = "/App/Account/Content/Calendar/New/AppointmentOverlay/Content/New/SimilarPatients/Content/Content/SimilarPerson/Person/Details/Content/FirstName"
  
}) {
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
let similarPersonFirstNameValueData = fromData.useDataValue({ viewPath,
context: 'similar_person',
path: 'first_name',
})
let dtSpaceXxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxs'
        })
  return (<React.Fragment
>
<div
  data-testid="FirstName.Vertical"
  data-view-path={viewPath}
 style={{'--mt-1-2wk1cU': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS}}
 className={`views-block ${styles.Vertical}`}
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 text="First Name"
 weight="semibold"
/>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 marginTop={dtSpaceXxs}
 paddingBottom={dtSpaceXxs}
 data="similar_person.first_name"
 text={similarPersonFirstNameValueData}
/>
</div>
{children}
</React.Fragment>)
}